import styled from "@emotion/styled"
import { Box } from "@mui/material"

const DefaultCard = styled(Box)(({ theme }) => ({
    backgroundColor: theme?.palette?.background?.paper || 'white',
    border: theme?.palette?.mode === 'light' ? '1px solid #EFEEF0' : '1px solid #a9a9a9',
    borderRadius: '20px',
    padding: '16px',
    boxShadow: theme?.palette?.mode === 'light' ? '0px 2px 10px 0px rgba(237, 229, 244, 0.48)' : 'none',
    '@media screen and (max-width:900px)': {
        padding: '12px',
        borderRadius: '8px'
    }
}));

export { DefaultCard };
